<template>
  <div type="flex" justify="center">
    <div id="otpContainer" class="container">
      <v-otp-input
        ref="otpValue"
        input-classes="otp-input"
        :num-inputs="6"
        :should-auto-focus="true"
        :is-input-num="true"
        separator="-"
        :conditional-class="['one', 'two', 'three', 'four']"
        :is-disabled="disableInput"
        @on-complete="handleOtpComplete"
        @on-change="handleOtpChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disableInput: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update-otp-value', 'otp-enter-complete'],
  methods: {
    handleOtpChange(enteredOtp) {
      this.$emit('update-otp-value', enteredOtp);
    },
    handleOtpComplete(enteredOtp){
      this.$emit('update-otp-value', enteredOtp);
      this.$emit('otp-enter-complete')
    },
    clearInput() {
      this.$refs.otpValue.clearInput();
    },
  },
};
</script>

<style>
#otpContainer {
  padding: 10px 40px;
}

.otp-input {
  width: 40px;
  height: 40px;
  padding: 10px 10px;
  margin: 0px 10px 10px 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

.otp-input.is-complete {
  background-color: #e4e4e4;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#otpContainer input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}
</style>
